import { CircularProgress, ConfirmationModal, Text } from "@digitalreality/ui";
import React, { Dispatch, SetStateAction, useState } from "react";
import { useAppState } from "../../StateStore/Store";
import { deleteProjectAsync } from "../../Services/ProjectsService";
import { deleteProjectFromList } from "../../StateStore/ProjectList/ProjectListActions";
import { useTranslation } from "react-i18next";

type ModalParams = {
  open: boolean;
  setState: Dispatch<SetStateAction<{ open: boolean; projectName: string }>>;
  projectName: string;
};

const DeleteProjectModal = function ({
  open,
  projectName,
  setState,
}: ModalParams) {
  const { t } = useTranslation();
  const { dispatch } = useAppState();
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const handleProjectDelete = () => {
    setLoading(true);
    deleteProjectAsync(projectName).then((response) => {
      if (response.success) {
        dispatch(deleteProjectFromList(projectName));
        handleModalClose();
      } else {
        setError(true);
      }
      setLoading(false);
    });
  };

  const handleModalClose = () => {
    setState({ open: false, projectName: "" });
    setError(false);
  };

  const title = `Are you sure you want to delete project ${projectName}?`;
  return (
    <ConfirmationModal
      title={title}
      size="small"
      open={open}
      cancelButtonText={t("Texts.Cancel")}
      confirmButtonText={t("Texts.Delete")}
      onCancel={handleModalClose}
      onConfirm={handleProjectDelete}
    >
      {error && (
        <Text size={5} color="red">
          * Can not delete project
        </Text>
      )}
      {loading && <CircularProgress />}
    </ConfirmationModal>
  );
};

export default DeleteProjectModal;
